/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useAuth, signOut, showAlert } from '../context/authContext';

/**
 * Listens to App's incoming events. Like user idle state, no internet connections, etc
 * @param WrappedComponent
 * @returns
 */
const withAppListener = <P extends Record<string, unknown>>(
  WrappedComponent: React.ComponentType<P>,
) =>
  function (props: P) {
    const [, dispatch] = useAuth();

    /**
     *  APP IDLE STATE LISTENER
     */
    useIdleTimer({
      // timeout: 1000 * 60 * 60,
      timeout: 1000 * 60 * 60 * 24, // 24 hours
      onIdle: () => signOut(dispatch, 'SESSION'),
      onActive: () => false,
      debounce: 250,
    });

    /**
     *  INTERNET CONNECTIVITY LISTENER
     */
    React.useEffect(() => {
      function internetConnectivityListener() {
        const condition = navigator.onLine ? 'online' : 'offline';

        if (condition === 'online') {
          const webPing = setInterval(() => {
            fetch('//google.com', {
              mode: 'no-cors',
            })
              .then(() => {
                // Set state to `true` when user has internet

                showAlert(dispatch);

                return clearInterval(webPing);
              })
              .catch(() => {
                // Set state to `false` when user has internet

                showAlert(dispatch, {
                  show: true,
                  message: `Oops! Looks like you are currently Offline. Could not connect to Swiftinflow!`,
                  type: 'ERROR',
                });
              });
          }, 2000);
          return;
        }

        // Set state to `false` when user has internet

        showAlert(dispatch, {
          show: true,
          message: `Oops! Looks like you are currently Offline. Could not connect to Swiftinflow!`,
          type: 'ERROR',
        });
      }

      window.addEventListener('online', internetConnectivityListener);

      window.addEventListener('offline', internetConnectivityListener);

      return function cleanup() {
        window.removeEventListener('online', internetConnectivityListener);

        window.removeEventListener('offline', internetConnectivityListener);
      };
    }, [dispatch]);

    return <WrappedComponent {...props} />;
  };

export default withAppListener;
